/**
 * 路由级骨架屏。
 *
 * 两条硬要求：
 *   1) 尺寸稳定：骨架必须和真实内容同高，否则懒加载 chunk 到达时会触发 CLS；
 *   2) 不用 spinner 做整页占位：转圈只是「告诉你它在等」，骨架同时告诉用户「等什么」。
 */

export interface RouteSkeletonProps {
  readonly variant?: "cards" | "table";
}

export function RouteSkeleton({ variant = "cards" }: RouteSkeletonProps) {
  if (variant === "table") {
    return (
      <div className="p-page" aria-busy="true" aria-live="polite">
        <div className="skeleton h-4 w-40" />
        <div className="mt-3 rounded-lg border border-line bg-surface" style={{ minHeight: 480 }}>
          {Array.from({ length: 12 }, (_unused, index) => (
            <div
              key={index}
              className="flex items-center gap-3 border-b border-line-subtle px-3"
              style={{ height: "var(--row-height)" }}
            >
              <div className="skeleton h-3 w-[45%]" />
              <div className="skeleton h-3 w-[15%]" />
              <div className="skeleton h-3 w-[15%]" />
            </div>
          ))}
        </div>
      </div>
    );
  }

  return (
    <div className="p-page" aria-busy="true" aria-live="polite">
      <div className="skeleton h-5 w-48" />
      <div className="mt-2 skeleton h-3 w-72" />
      <div className="mt-4 grid gap-3 lg:grid-cols-4" style={{ minHeight: 108 }}>
        {Array.from({ length: 4 }, (_unused, index) => (
          <div key={index} className="rounded-lg border border-line bg-surface p-3" style={{ height: 108 }}>
            <div className="skeleton h-3 w-24" />
            <div className="mt-3 skeleton h-6 w-32" />
            <div className="mt-3 skeleton h-3 w-28" />
          </div>
        ))}
      </div>
      <div className="mt-4 rounded-lg border border-line bg-surface p-4" style={{ minHeight: 220 }}>
        <div className="skeleton h-3 w-40" />
        <div className="mt-3 skeleton h-3 w-full" />
        <div className="mt-2 skeleton h-3 w-[92%]" />
        <div className="mt-2 skeleton h-3 w-[86%]" />
      </div>
    </div>
  );
}
